/* eslint-disable no-unused-vars */
import 'semantic-ui-css/semantic.min.css';
import './_App.scss';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import { Helmet } from 'react-helmet';
import { ModalController } from 'controls/modals';
import { ErrorBoundary } from 'components/common';
import { RCWPage } from 'components/pages/RCWPage/RCWPage';
import { AnchorLink } from 'components/atoms/AnchorLink/AnchorLink';
import { useNotificationScript } from 'controls/hooks/useNotificationScript';

export const App = hot(() => {
  const modals = useSelector((state) => state.modals);
  const notificationScript = useNotificationScript();

  return (
    <div className='App'>
      { notificationScript
      && (
      <Helmet>
        <script>
          {notificationScript}
        </script>
      </Helmet>
      )}
      <link
        href='https://unpkg.com/tachyons@4/css/tachyons.min.css'
      />
      <link rel='preconnect' href='https://fonts.gstatic.com' />
      <link href='https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap' rel='stylesheet' />
      <link href='https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap' rel='stylesheet' />
      <AnchorLink />
      <ErrorBoundary>
        <Switch>
          <Route path='/' component={RCWPage} />
        </Switch>
      </ErrorBoundary>
      <ModalController modals={modals} />
    </div>
  );
});
